module.exports = __webpack_public_path__ + "img/5.35e845f5.png";